import React from "react";
import Imagen from "../../images/modulo4/mapamundi.png";
import LayoutActividad from "../../components/LayoutActividad";

import { modulo4 } from "../../routes/Module4";
import { modulo5 } from "../../routes/Module5";

import Sidebar from "./Sidebar";
import GuiaDocente from "../../components/GuiaDocente";
import AudioPlayer from "../../audioPlayer/AudioPlayer";
import Audio from "../../audios/modulo4/Cierre.mp3";

const Modulo1Conclusion = () => {
  const crumbs = [
    {
      title: modulo4.title,
      url: "/" + modulo4.url,
    },
    {
      title: `Cierre`,
      url: "cierre",
    },
  ];
  const pages = {
    titlePrev: `${modulo4.content[0].name} - ${modulo4.content[0].activities[7].name}`,
    linkPrev: `${modulo4.url}/${modulo4.content[0].path}/${modulo4.content[0].activities[7].path}`,
  };
  const metadata = {
    color: modulo4.color,
    title: `${modulo4.title}`,
    name: modulo4.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h1 className="my-5">Así es mi país en el mundo</h1>
      <AudioPlayer track={Audio} />

      <p>Para terminar, pensemos…</p>
      <ul>
        <li>¿Cuántos continentes se ven en el mapa?</li>
        <li>¿En cuál vivimos nosotros?</li>
        <li>¿Es bueno que haya diferencias entre los países? ¿Por qué?</li>
        <li>
          Si viajaras a otros países, ¿qué le contarías a la gente sobre el
          Perú?
        </li>
      </ul>

      <div className="header-img">
        <img src={Imagen} className="card-img-top full-width" alt="..." />
      </div>

      <GuiaDocente>
        <p>
          Lea el título y las preguntas que se plantean. Dialoguen acerca de las
          respuestas. La idea es reconocer que hay mucha diversidad en el mundo:
          idiomas, territorios, paisajes, costumbres. La diversidad es difícil
          de manejar pero es sobre todo una riqueza. Lo mismo vale si hablamos
          de nuestro país.
        </p>
      </GuiaDocente>
      <div className="unit-options my-5 d-flex flex-column">
        <p>Ir al siguiente módulo:</p>
        <a href={"/" + modulo5.url}>
          <button className={`btn btn-${modulo4.color} me-2`}>
            {modulo5.title + " >"}
          </button>
        </a>
      </div>
    </LayoutActividad>
  );
};

export default Modulo1Conclusion;
